import { AuthnTransaction } from '@okta/okta-auth-js';

const mapAuthnTransactionToMfaFactors = (result: AuthnTransaction): any[] => {
  // While the type AuthnTransaction doesn't define `data` as a property,
  // it is part of the returned object.
  // Using the result.data._embedded.factors instead of result.factors
  // due to the existence of functions in result.factors which will cause the state to null out.
  // result.factors also does not have the link objects.
  const factors = result.data._embedded.factors.map((factor) => {
    let displayName = factor.provider;
    if (factor.provider === 'GOOGLE') {
      displayName = 'Authenticator App';
    } else if (
      factor.provider === 'OKTA' &&
      factor.factorType === 'token:software:totp'
    ) {
      displayName = 'Okta Verify';
    } else if (factor.factorType === 'email') {
      displayName = 'Email';
    }
    return {
      ...factor,
      displayName,
      links: factor._links,
      stateToken: result.data.stateToken,
    };
  });
  return factors;
};
export default mapAuthnTransactionToMfaFactors;
